module.exports = __webpack_public_path__ + "img/pro_two_3.e963a5b4.jpg";